/**
 * @brief Instantiation of Vuex store allow to centralize data management.
 * @bug No known bugs.
 */

import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// Import all module declare in sub-folder /modules
import modules from './modules'

Vue.use(Vuex)

// Declaration of Vuex store
const store = new Vuex.Store({
  modules,
  plugins: [createPersistedState()], // allow data persistance with localStorage management
  strict: process.env.NODE_ENV !== 'production',
})

export default store
